import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { RenderContextComponent } from '../../../../../../../../models/base/render-context-component';
import type { VariantsGroupedByBrand } from '../../../../../../models/variants-grouped-by-brand';
import { ShelfTalkerPricingViewModel } from './shelf-talker-pricing-view-model';
import type { GroupedByBrandShelfTalkerCardData } from '../../../../../../../../models/shelf-talkers/grouped-by-brand-shelf-talker-card-data';
import { LocationPriceStream } from '../../../../../../../../models/enum/shared/location-price-stream';

@Component({
  selector: 'app-shelf-talker-pricing',
  templateUrl: './shelf-talker-pricing.component.html',
  styleUrls: ['./shelf-talker-pricing.component.scss'],
  providers: [ShelfTalkerPricingViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ShelfTalkerPricingComponent extends RenderContextComponent implements OnChanges {
  constructor(public viewModel: ShelfTalkerPricingViewModel) {
    super();
  }

  @Input() shelfTalkerCardData: GroupedByBrandShelfTalkerCardData;
  @Input() variantsGroupedByBrand: VariantsGroupedByBrand;
  @Input() displayDecimalCharacter: boolean = true;
  @Input() lineHeightScaleVsFontSize = 1.2;
  @Input() adjustLineHeight = true;
  @Input() maxWidthInPx: number;
  @Input() maxHeightInPx: number;
  @Input() transparentWhileScaling: boolean;
  @Input() priceStream: LocationPriceStream = LocationPriceStream.Default;

  setupViews() {}

  setupBindings() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.shelfTalkerCardData) {
      this.viewModel.connectToShelfTalkerCardData(this.shelfTalkerCardData);
    }
    if (changes.variantsGroupedByBrand) {
      this.viewModel.connectToVariantsGroupedByBrand(this.variantsGroupedByBrand);
    }
    if (changes.displayDecimalCharacter) {
      this.viewModel.connectToDisplayDecimalCharacter(this.displayDecimalCharacter);
    }
    if (changes.priceStream) {
      this.viewModel.connectToPriceStream(this.priceStream);
    }
  }
}
